<p-dialog showHeader="false" [(visible)]="display" [modal]="true" width="500" [baseZIndex]="10000" [closable]="false"
            [header]="title" (onShow)="showDialogMaximized(dialog)" (onHide)="noOp()" #dialog>

    <div class="animated fadeIn" [ngClass]="{ 'shrink-dialog': hasInnerMenu }">
        <div class="row">
            <div class="col-md-12">
                <ng-container [ngTemplateOutlet]="template"></ng-container>
            </div>
        </div>
    </div>

    <p-footer>
        <button type="button" [disabled]="disabled" class="btn btn-secondary btn-sm" (click)="acceptDialog()"><i class="fa fa-check"></i> Aceptar</button>
        <button type="button" [disabled]="disabledCancel" class="btn btn-secondary btn-sm" (click)="cancelDialog()"><i class="fa fa-times"></i> Cancelar</button>
    </p-footer>

</p-dialog>